export const MoroccanDivider = () => (
  <div className="moroccan-divider" aria-hidden="true">
    <span className="line" />
    <svg width="34" height="34" viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1">
      <path d="M20 2 L38 20 L20 38 L2 20 Z" />
      <path d="M20 10 L30 20 L20 30 L10 20 Z" />
      <circle cx="20" cy="20" r="3" fill="currentColor" />
    </svg>
    <span className="line" />
  </div>
);
